// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lesson-view {
  max-width: 600px;
  margin: 0 auto;
}

.lesson-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.progress-indicator {
  background: var(--primary);
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-weight: 700;
}

.progress-bar {
  height: 8px;
  background: var(--border);
  border-radius: 4px;
  margin-bottom: 32px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, var(--primary), var(--success));
  border-radius: 4px;
  transition: width 0.3s ease;
}

.card-container {
  margin-bottom: 32px;
}

.lesson-controls {
  display: flex;
  justify-content: space-between;
  gap: 16px;
}

.lesson-controls button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Completion screen */
.lesson-complete {
  text-align: center;
  padding: 40px 20px;
  max-width: 500px;
  margin: 0 auto;
}

.complete-icon {
  font-size: 80px;
  margin-bottom: 16px;
}

.lesson-complete h1 {
  font-size: 36px;
  margin-bottom: 8px;
}

.lesson-complete p {
  font-size: 18px;
  color: var(--text-light);
  margin-bottom: 24px;
}

.points-earned {
  background: linear-gradient(135deg, #FFD700, #FFA500);
  color: #333;
  padding: 16px 32px;
  border-radius: 20px;
  font-size: 28px;
  font-weight: 800;
  display: inline-block;
  margin-bottom: 32px;
}

.complete-actions {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* Empty lesson state */
.empty-lesson {
  text-align: center;
  padding: 60px 20px;
  background: white;
  border-radius: 20px;
  box-shadow: var(--shadow);
}

.empty-icon {
  font-size: 64px;
  margin-bottom: 16px;
}

.empty-lesson h3 {
  font-size: 22px;
  margin-bottom: 8px;
  color: var(--text);
}

.empty-lesson p {
  font-size: 16px;
  color: var(--text-light);
  margin-bottom: 24px;
}

/* Lesson stats */
.lesson-stats {
  display: flex;
  gap: 16px;
  justify-content: center;
  margin-bottom: 24px;
}

.lesson-stats .stat-item {
  background: white;
  padding: 12px 20px;
  border-radius: 12px;
  font-weight: 600;
  box-shadow: var(--shadow);
}

/* Learning methods */
.learning-methods {
  margin-bottom: 32px;
}

.learning-methods h3 {
  font-size: 18px;
  margin-bottom: 16px;
  color: var(--text);
}

.methods-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 16px;
}

.method-tile {
  background: white;
  border: 2px solid var(--border);
  border-radius: 16px;
  padding: 20px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.method-tile:hover {
  border-color: var(--primary);
  transform: translateY(-2px);
  box-shadow: var(--shadow);
}

.method-icon {
  font-size: 32px;
}

.method-name {
  font-weight: 700;
  font-size: 16px;
  color: var(--text);
}

.method-desc {
  font-size: 12px;
  color: var(--text-light);
}

/* Content list */
.lesson-content-list {
  margin-bottom: 32px;
}

.lesson-content-list h3 {
  font-size: 18px;
  margin-bottom: 16px;
  color: var(--text);
}

.content-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.content-item {
  background: white;
  border-radius: 12px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  box-shadow: var(--shadow-sm);
}

.content-item.sentence {
  background: #f0f7ff;
}

.content-english {
  font-weight: 600;
  color: var(--primary);
  flex: 1 1;
}

.content-polish {
  color: var(--text-light);
  flex: 1 1;
}

.speak-btn-small {
  background: var(--accent);
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s;
}

.speak-btn-small:hover {
  transform: scale(1.1);
}

/* Self-evaluation */
.self-eval-box {
  background: white;
  border-radius: 16px;
  padding: 24px;
  text-align: center;
  box-shadow: var(--shadow);
}

.self-eval-prompt {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
  color: var(--text);
}

.self-eval-buttons {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.self-eval-btn {
  padding: 16px 24px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 12px;
  border: 2px solid transparent;
  cursor: pointer;
  transition: all 0.2s ease;
}

.self-eval-btn.easy {
  background: #e8f5e9;
  color: #2e7d32;
  border-color: #4caf50;
}

.self-eval-btn.easy:hover {
  background: #c8e6c9;
}

.self-eval-btn.ok {
  background: #fff3e0;
  color: #e65100;
  border-color: #ff9800;
}

.self-eval-btn.ok:hover {
  background: #ffe0b2;
}

.self-eval-btn.hard {
  background: #ffebee;
  color: #c62828;
  border-color: #f44336;
}

.self-eval-btn.hard:hover {
  background: #ffcdd2;
}

.self-eval-remaining {
  margin-top: 16px;
  font-size: 14px;
  color: var(--text-light);
}

/* Challenge modal */
.card-container.blurred {
  filter: blur(8px);
  pointer-events: none;
}

.challenge-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.challenge-content {
  background: white;
  border-radius: 20px;
  padding: 32px;
  max-width: 400px;
  width: 100%;
  text-align: center;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}

.challenge-content h3 {
  font-size: 22px;
  margin-bottom: 16px;
  color: var(--text);
}

.challenge-content p {
  font-size: 16px;
  margin-bottom: 16px;
  color: var(--text-light);
}

.challenge-content strong {
  color: var(--primary);
}

.challenge-input {
  width: 100%;
  padding: 16px;
  font-size: 18px;
  border: 2px solid var(--border);
  border-radius: 12px;
  margin-bottom: 16px;
  text-align: center;
}

.challenge-input:focus {
  outline: none;
  border-color: var(--primary);
}

.challenge-feedback {
  font-size: 18px;
  font-weight: 600;
  padding: 12px;
  border-radius: 12px;
  margin-top: 16px;
}

.challenge-feedback.success {
  background: #e8f5e9;
  color: #2e7d32;
}

.challenge-feedback.retry {
  background: #fff3e0;
  color: #e65100;
  margin-bottom: 16px;
}

.challenge-feedback.fail {
  background: #ffebee;
  color: #c62828;
}

.challenge-close-btn {
  margin-top: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/LessonView.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kEAAkE;EAClE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,SAAO;AACT;;AAEA;EACE,wBAAwB;EACxB,SAAO;AACT;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,wBAAwB;AAC1B;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,+BAA+B;EAC/B,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".lesson-view {\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.lesson-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.progress-indicator {\n  background: var(--primary);\n  color: white;\n  padding: 8px 16px;\n  border-radius: 20px;\n  font-weight: 700;\n}\n\n.progress-bar {\n  height: 8px;\n  background: var(--border);\n  border-radius: 4px;\n  margin-bottom: 32px;\n  overflow: hidden;\n}\n\n.progress-fill {\n  height: 100%;\n  background: linear-gradient(90deg, var(--primary), var(--success));\n  border-radius: 4px;\n  transition: width 0.3s ease;\n}\n\n.card-container {\n  margin-bottom: 32px;\n}\n\n.lesson-controls {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.lesson-controls button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Completion screen */\n.lesson-complete {\n  text-align: center;\n  padding: 40px 20px;\n  max-width: 500px;\n  margin: 0 auto;\n}\n\n.complete-icon {\n  font-size: 80px;\n  margin-bottom: 16px;\n}\n\n.lesson-complete h1 {\n  font-size: 36px;\n  margin-bottom: 8px;\n}\n\n.lesson-complete p {\n  font-size: 18px;\n  color: var(--text-light);\n  margin-bottom: 24px;\n}\n\n.points-earned {\n  background: linear-gradient(135deg, #FFD700, #FFA500);\n  color: #333;\n  padding: 16px 32px;\n  border-radius: 20px;\n  font-size: 28px;\n  font-weight: 800;\n  display: inline-block;\n  margin-bottom: 32px;\n}\n\n.complete-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n/* Empty lesson state */\n.empty-lesson {\n  text-align: center;\n  padding: 60px 20px;\n  background: white;\n  border-radius: 20px;\n  box-shadow: var(--shadow);\n}\n\n.empty-icon {\n  font-size: 64px;\n  margin-bottom: 16px;\n}\n\n.empty-lesson h3 {\n  font-size: 22px;\n  margin-bottom: 8px;\n  color: var(--text);\n}\n\n.empty-lesson p {\n  font-size: 16px;\n  color: var(--text-light);\n  margin-bottom: 24px;\n}\n\n/* Lesson stats */\n.lesson-stats {\n  display: flex;\n  gap: 16px;\n  justify-content: center;\n  margin-bottom: 24px;\n}\n\n.lesson-stats .stat-item {\n  background: white;\n  padding: 12px 20px;\n  border-radius: 12px;\n  font-weight: 600;\n  box-shadow: var(--shadow);\n}\n\n/* Learning methods */\n.learning-methods {\n  margin-bottom: 32px;\n}\n\n.learning-methods h3 {\n  font-size: 18px;\n  margin-bottom: 16px;\n  color: var(--text);\n}\n\n.methods-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n  gap: 16px;\n}\n\n.method-tile {\n  background: white;\n  border: 2px solid var(--border);\n  border-radius: 16px;\n  padding: 20px;\n  text-align: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n}\n\n.method-tile:hover {\n  border-color: var(--primary);\n  transform: translateY(-2px);\n  box-shadow: var(--shadow);\n}\n\n.method-icon {\n  font-size: 32px;\n}\n\n.method-name {\n  font-weight: 700;\n  font-size: 16px;\n  color: var(--text);\n}\n\n.method-desc {\n  font-size: 12px;\n  color: var(--text-light);\n}\n\n/* Content list */\n.lesson-content-list {\n  margin-bottom: 32px;\n}\n\n.lesson-content-list h3 {\n  font-size: 18px;\n  margin-bottom: 16px;\n  color: var(--text);\n}\n\n.content-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.content-item {\n  background: white;\n  border-radius: 12px;\n  padding: 12px 16px;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  box-shadow: var(--shadow-sm);\n}\n\n.content-item.sentence {\n  background: #f0f7ff;\n}\n\n.content-english {\n  font-weight: 600;\n  color: var(--primary);\n  flex: 1;\n}\n\n.content-polish {\n  color: var(--text-light);\n  flex: 1;\n}\n\n.speak-btn-small {\n  background: var(--accent);\n  border: none;\n  border-radius: 50%;\n  width: 32px;\n  height: 32px;\n  font-size: 14px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 0.2s;\n}\n\n.speak-btn-small:hover {\n  transform: scale(1.1);\n}\n\n/* Self-evaluation */\n.self-eval-box {\n  background: white;\n  border-radius: 16px;\n  padding: 24px;\n  text-align: center;\n  box-shadow: var(--shadow);\n}\n\n.self-eval-prompt {\n  font-size: 18px;\n  font-weight: 600;\n  margin-bottom: 16px;\n  color: var(--text);\n}\n\n.self-eval-buttons {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.self-eval-btn {\n  padding: 16px 24px;\n  font-size: 16px;\n  font-weight: 600;\n  border-radius: 12px;\n  border: 2px solid transparent;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.self-eval-btn.easy {\n  background: #e8f5e9;\n  color: #2e7d32;\n  border-color: #4caf50;\n}\n\n.self-eval-btn.easy:hover {\n  background: #c8e6c9;\n}\n\n.self-eval-btn.ok {\n  background: #fff3e0;\n  color: #e65100;\n  border-color: #ff9800;\n}\n\n.self-eval-btn.ok:hover {\n  background: #ffe0b2;\n}\n\n.self-eval-btn.hard {\n  background: #ffebee;\n  color: #c62828;\n  border-color: #f44336;\n}\n\n.self-eval-btn.hard:hover {\n  background: #ffcdd2;\n}\n\n.self-eval-remaining {\n  margin-top: 16px;\n  font-size: 14px;\n  color: var(--text-light);\n}\n\n/* Challenge modal */\n.card-container.blurred {\n  filter: blur(8px);\n  pointer-events: none;\n}\n\n.challenge-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.challenge-content {\n  background: white;\n  border-radius: 20px;\n  padding: 32px;\n  max-width: 400px;\n  width: 100%;\n  text-align: center;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n}\n\n.challenge-content h3 {\n  font-size: 22px;\n  margin-bottom: 16px;\n  color: var(--text);\n}\n\n.challenge-content p {\n  font-size: 16px;\n  margin-bottom: 16px;\n  color: var(--text-light);\n}\n\n.challenge-content strong {\n  color: var(--primary);\n}\n\n.challenge-input {\n  width: 100%;\n  padding: 16px;\n  font-size: 18px;\n  border: 2px solid var(--border);\n  border-radius: 12px;\n  margin-bottom: 16px;\n  text-align: center;\n}\n\n.challenge-input:focus {\n  outline: none;\n  border-color: var(--primary);\n}\n\n.challenge-feedback {\n  font-size: 18px;\n  font-weight: 600;\n  padding: 12px;\n  border-radius: 12px;\n  margin-top: 16px;\n}\n\n.challenge-feedback.success {\n  background: #e8f5e9;\n  color: #2e7d32;\n}\n\n.challenge-feedback.retry {\n  background: #fff3e0;\n  color: #e65100;\n  margin-bottom: 16px;\n}\n\n.challenge-feedback.fail {\n  background: #ffebee;\n  color: #c62828;\n}\n\n.challenge-close-btn {\n  margin-top: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
